import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import {
    faSearch,
    faCheck,
    faPhone,
    faEnvelope,
    faSignInAlt,
    faSignOutAlt,
    faExclamationCircle,
    faExternalLinkAlt,
    faLowVision
} from '@fortawesome/free-solid-svg-icons'

library.add(faSearch, faSignOutAlt, faPhone, faEnvelope, faFacebookSquare, faSignInAlt, faExclamationCircle, faCheck, faExternalLinkAlt, faLowVision)

Vue.component('font-awesome-icon', FontAwesomeIcon)
